var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.90701C21.2504 6.23439 20.4565 6.44905 19.644 6.54401C20.4968 6.04324 21.138 5.24912 21.448 4.31001C20.64 4.78034 19.7587 5.11161 18.841 5.29001C18.4545 4.88522 17.9897 4.5634 17.4748 4.34419C16.9598 4.12498 16.4056 4.01298 15.846 4.01501C13.58 4.01501 11.743 5.82501 11.743 8.05501C11.743 8.37101 11.779 8.68001 11.849 8.97501C10.2236 8.89771 8.63212 8.48242 7.17617 7.75565C5.72022 7.02888 4.43176 6.00659 3.393 4.75401C3.02883 5.36841 2.83742 6.06979 2.839 6.78401C2.8397 7.45198 3.00683 8.10924 3.32529 8.6964C3.64375 9.28357 4.1035 9.78212 4.663 10.147C4.01248 10.126 3.37602 9.95234 2.805 9.64001V9.69001C2.805 11.648 4.22 13.281 6.095 13.653C5.74261 13.7465 5.37958 13.7939 5.015 13.794C4.75 13.794 4.493 13.769 4.242 13.719C4.51008 14.5269 5.02311 15.2313 5.70982 15.7344C6.39653 16.2374 7.22284 16.5141 8.074 16.526C6.61407 17.6506 4.82182 18.2581 2.979 18.253C2.647 18.253 2.321 18.233 2 18.197C3.88125 19.3877 6.06259 20.0183 8.289 20.015C15.836 20.015 19.962 13.858 19.962 8.51901L19.948 7.99601C20.7529 7.42968 21.4481 6.72186 22 5.90701Z",
    fill: "#E2E8F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0cfeff716bc0a3c32c8650b993e4df43.svg";
export { ForwardRef as ReactComponent };